import React from 'react';
import { message } from 'antd';
import { managerApi } from 'apis/manager/managerApis';
import { theme } from 'utils/style/theme';
import SmallModal from 'components/form/SmallModal';
import VerticalForm from 'components/form/DefaultForm';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
/**
 * * 관리자 정보 수정 모달
 */

const ManagerUpdateModal = ({
  visible,
  setVisible,
  managerData,
  setManagerData,
  fetchData,
  authDropData,
}) => {
  const { t } = useTranslation();
  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === 'userMaster') {
      // userMaster: 0 (마스터 아님) /1 (마스터)
      setManagerData({ ...managerData, userMaster: checked ? 1 : 0 });
    } else {
      setManagerData({ ...managerData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    const res = await managerApi.update(managerData);
    if (!res) {
      return false;
    }
    fetchData();
    setVisible(false);
    message.success(t('managerID.managerUpdateModal.submitSuccessMessage'), 1);
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible(false);
  };

  return (
    <SmallModal
      title={t('managerID.managerUpdateModal.title')}
      visible={visible}
      onCancel={handleClose}
      footer={
        <DefaultButton onClick={handleSubmit}>
          {t('managerID.managerUpdateModal.edit')}
        </DefaultButton>
      }
    >
      <VerticalForm>
        <DefaultInput
          title={t('managerID.managerUpdateModal.userName')}
          name='userName'
          value={managerData?.userName}
          onChange={handleInputChange}
        />
        <DefaultInput
          title={t('managerID.managerUpdateModal.userEmail')}
          name='userEmail'
          value={managerData?.userEmail}
          onChange={handleInputChange}
        />
        <DefaultInput
          title={t('managerID.managerUpdateModal.userOrganization')}
          name='userOrganization'
          value={managerData?.userOrganization}
          onChange={handleInputChange}
          style={{
            marginBottom: '1rem',
          }}
        />

        <div
          className='horizontal_wrap'
          style={{
            marginBottom: theme.margins.bottomInModal,
          }}
        >
          <h3>{t('managerID.managerUpdateModal.userMaster')}</h3>
          <CheckboxOneType
            name='userMaster'
            checked={managerData?.userMaster === 1 ? true : false}
            onChange={handleInputChange}
          />
        </div>
        {/* 마스터 권한이 아닐 때 보여주기 */}
        {managerData?.userMaster === 0 && (
          <>
            <DefaultRadio
              title={t('managerID.managerUpdateModal.userPlatform')}
              name='userPlatform'
              optionList={authDropData}
              defaultValue={managerData?.userPlatform}
              onChange={handleInputChange}
              style={{ marginBottom: theme.margins.bottomInModal }}
            />
            <DefaultRadio
              title={t('managerID.managerUpdateModal.userManagement')}
              name='userManagement'
              optionList={authDropData}
              defaultValue={managerData?.userManagement}
              onChange={handleInputChange}
            />
          </>
        )}
      </VerticalForm>
    </SmallModal>
  );
};

export default ManagerUpdateModal;
